import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";

import { getUnlockedTutorialsListPath } from "../../resources/unlockedTutorials/unlockedTutorialsResourceConsts";
import { unlockedTutorialsResourceStruct } from "../../resources/unlockedTutorials/unlockedTutorialsResourceStruct";

export const getUnlockedTutorialsQuery = (
  jsonApi: JsonApiClient,
  { userGroupId }: { userGroupId: string }
) => {
  return jsonApi.getMany({
    path: getUnlockedTutorialsListPath(userGroupId),
    responseStruct: getUnlockedTutorialsResponseStruct,
  });
};

const getUnlockedTutorialsResponseStruct = createResponseStruct({
  data: unlockedTutorialsResourceStruct,
});

export type GetUnlockedTutorialsResponse = sup.Infer<
  typeof getUnlockedTutorialsResponseStruct
>;
